// extracted by mini-css-extract-plugin
export default {"header":"BrandedNav_header__aMruO","header-height-xsmall":"BrandedNav_header-height-xsmall__EjHLD"};